import {
    calculatePayment,
    calculateTransaction,
    calculateTransactionItem
} from "../../helper"

import {
    getField,
    updateField
} from "vuex-map-fields"

function calculateAdditionalCost(state) {
    state.additional_cost_total = _.sumBy(state.additional_costs, 'nominal');
}

const getDefaultState = () => {
    let today = (new Date()).toISOString()
    return {
        purchase_date: today,
        supplier_id: '',
        invoice_code: '',
        payment_total: 0,
        payment_done: 0,
        payment_remain: 0,
        payment_type: 'cash', // as default
        price_total: 0,
        price_total_after_discount: 0,
        price_total_after_tax: 0,
        discount_nominal_from_item: 0,
        discount_word_from_total: '',
        discount_nominal_from_total: 0,
        discount_nominal: 0,
        tax_nominal_from_item: 0,
        tax_word_from_total: '',
        tax_nominal_from_total: 0,
        tax_nominal: 0,
        memo: '',
        created_by_id: '',

        additional_cost_total: 0, // exclude from tax and discount, independently
        additional_costs: [],

        // purchase items
        purchase_items: [
            getDefaultItemFormState()
        ],

        // purchase payments
        purchase_payments: [
            // getDefaultPaymentFormState()
        ]
    }
}

const getDefaultItemFormState = () => {
    return {
        purchase_id: '',
        product: null,
        product_id: '',
        qty_bonus: 0,
        qty: 1,
        qty_total: 1,
        unit: null,
        unit_id: '',
        n_price: 0,
        price: 0,
        discount_word: '',
        discount_nominal: 0,
        price_after_discount: 0,
        expire_date: '',
    }
}

const getDefaultPaymentFormState = () => {
    return {
        purchase_id: '',
        due_date: null,
        due_date_code: '',
        paid_date_time: (new Date()).toISOString(),
        from_user_cash_id: '',
        to: '',
        nominal: 0,
        status_paid: true,
        memo: ''
    }
}

export default ({
    namespaced: true, 
    // variable
    state: getDefaultState(),
    // must syncronous
    mutations: {
        RESET_FORM(state) {
            Object.assign(state, getDefaultState())
        },
        ADD_ADDITIONAL_COST_TO_TRANSACTION(state) {
            state.additional_costs.push({
                label: '',
                nominal: 0
            })
        },
        // add product item row
        ADD_PRODUCT_ITEMS_ROW(state) {
            state.purchase_items.push(getDefaultItemFormState())
        },
        // add payment row
        ADD_TRANSACTION_PAYMENT_ROW(state) {
            let prepare = getDefaultPaymentFormState();
            // update to latest nominal
            let paymentTotal = state.payment_total
            let paymentNominalInForm = _.sumBy(state.purchase_payments, 'nominal') ?? 0
            prepare.nominal = paymentTotal - paymentNominalInForm
            state.purchase_payments.push(prepare)
            // calculate payment
            calculatePayment(state, state.purchase_payments)
        },
        CALCULATE_ADDITIONAL_COST(state) {
            let before = state.additional_cost_total
            // // calculate sum of item and save to total
            calculateAdditionalCost(state)
            
            let after = state.additional_cost_total
            // // add to payment
            let difference = after-before;

            state.payment_total += difference
            state.payment_remain += difference

            // pre payment nominal
            // initPrepaymentNominal(state)
        },
        CALCULATE_ITEM(state, purchaseItem) {
            calculateTransactionItem(purchaseItem, 'floor', 'floor', false)
        },
        CALCULATE_TRANSACTION_PAYMENT_ROW(state, purchasePayment) {
            // reset payment if status_paid change
            if (purchasePayment.status_paid) {
                purchasePayment.due_date = null,
                purchasePayment.due_date_code = ''
                purchasePayment.paid_date_time = (new Date()).toISOString()
            } else {
                // add 1 month
                let dateNextMonth = new Date()
                dateNextMonth.setMonth(dateNextMonth.getMonth() + 1)

                purchasePayment.due_date = dateNextMonth.toISOString().split('T')[0],
                purchasePayment.due_date_code = ''
                purchasePayment.paid_date_time = null
            }
            // calculate payment
            calculatePayment(state, state.purchase_payments)
        },
        CALCULATE_TRANSACTION(state) {
            calculateTransaction(state, state.purchase_items, false)
            // calculate payment
            calculatePayment(state, state.purchase_payments)
            // state.payment_total = state.price_total_after_tax
            // state.payment_done = _.sumBy(state.purchase_payments, function(p) {
            //     return p.status_paid ? p.nominal : 0
            // })
            // state.payment_remain = state.payment_total - state.payment_done
        },
        REMOVE_ITEM_FROM_TRANSACTION(state, itemIndex) {
            state.purchase_items.splice(itemIndex, 1)
        },
        REMOVE_ADDITIONAL_COST_FROM_TRANSACTION(state, itemIndex) {
            state.additional_costs.splice(itemIndex, 1)
            calculateAdditionalCost(state)
        },
        REMOVE_ALL_ITEM_FROM_TRANSACTION(state) {
            state.purchase_items = []
            // should have at least 1
            state.purchase_items.push(getDefaultItemFormState())
        },
        REMOVE_TRANSACTION_PAYMENT_ROW(state, paymentIndex) {
            state.purchase_payments.splice(paymentIndex, 1)
        },
        updateField

    },
    // can async
    actions: {
        productChanged({commit}, { product, purchaseItem }) {
            purchaseItem.product_id = product.id
            purchaseItem.unit = product.unit
            purchaseItem.unit_id = product.unit_id
            // reset expire if no expire, else -> init
            if(!product.status_can_expire) {
                purchaseItem.expire_date = null
            } else {
                let d = new Date()
                // add 30 days
                //d.setDate(d.getDate() + 30)
                // add 5 years
                d.setFullYear(d.getFullYear() + 5)
                purchaseItem.expire_date = d.toISOString().split('T')[0]
            }
        },
        updateItemCalculation({commit}, purchaseItem) {
            commit('CALCULATE_ITEM', purchaseItem)
            commit('CALCULATE_TRANSACTION')
        },
    },
    // call variable with custom display
    getters: {
        getField
    }
})
